__turbopack_context__.v({
  "paragraph": "_3oDIHG_paragraph",
});
